import React from 'react';

interface Props { bgImage?: string; }

export const Slide3Source: React.FC<Props> = ({ bgImage }) => (
  <div className="bs-slide-inner">
    <div className="bs-slide-bg" aria-hidden="true">
      {bgImage ? (
        <div
          className="bs-slide-bg-img"
          style={{ backgroundImage: `url(${bgImage})` }}
        />
      ) : (
        <div className="bs-slide-bg--source-fallback" />
      )}
      <div className="bs-overlay bs-overlay--heavy" />
    </div>

    <div className="bs-content">
      <span className="bs-label">FROM THE SOURCE</span>
      <h1 className="bs-headline">Products you won't find anywhere else.</h1>
      <p className="bs-subline">
        Sourced directly from the people who make them.<br />
        No middlemen. No markup. Just the real thing.
      </p>
    </div>
  </div>
);
